<template>
  <Modal modalName="addBookmarkModal" title="Dodaj zakładkę" @closed="closed" @saved="saveBookmark">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="name"
        :rules="nameRules"
        :counter="20"
        label="Nazwa zakładki"
        autofocus
        required
      ></v-text-field>
    </v-form>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Nazwa jest wymagana",
      v => (v && v.length <= 20) || "Nazwa musi mieć mniej niż 20 znaków"
    ]
  }),
  computed: {
    currentPosition() {
      return this.$store.getters.getMapCenter;
    },
    bookmarks() {
      return this.$store.getters.getBookmarks;
    }
  },
  methods: {
    saveBookmark() {
      if (this.$refs.form.validate()) {
        let payload = this.bookmarks.slice().concat({
          name: this.name,
          center_x: this.currentPosition[0],
          center_y: this.currentPosition[1],
          zoom: this.currentPosition[2]
        });
        this.$store.dispatch("addBookmark", payload).then(success => {
          if (success) {
            this.$modal.hide("addBookmarkModal");
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano zakładkę"
            );
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas dodawania zakładki wystąpił błąd"
            );
          }
        });
      }
    },
    closed() {
      this.name = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/AddBookmark.vue